import React from "react";

const Chapter5 = () => {
  return (
    <>
      <h2>Are nutrients regulated pollutants?</h2>
      <p>
        Yes. The US Environmental Protection Agency regulates nutrients in
        recreational water through the Clean Water Act and drinking water
        through the Safe Drinking Water Act. Colorado regulates phosphorus and
        nitrogen through the Water Quality Control Commission Regulations.
      </p>
    </>
  );
};

export default Chapter5;
